



















import { Theme } from '@/models';
import { Modal } from '@/components';
import Vue from 'vue';

export default Vue.extend({
  name: 'NotificationModal',
  components: {
    Modal,
  },
  props: {
    isOpen: Boolean,
  },
  methods: {
    confirm() {
      this.$emit('confirm');
    },
  },
  computed: {
    currentTheme(): Theme {
      return this.$store.state.themes.current;
    },
  },
});
